import React from "react";

const PasswordCellRenderer = (props) => {
    const { value } = props;

    return (
        <div className="">
          <div className="double-renderer-field">
              &#x2022;&#x2022;&#x2022;&#x2022;&#x2022;&#x2022;&#x2022;&#x2022;
          </div>
        </div>
    );
};

export default PasswordCellRenderer;
